import React, { FC } from "react";
import { useFormikContext } from "formik";
import useTranslations from "./useTranslations";
import Dialog from "../../Unknown/Dialog";
import DialogTitle from "../../Unknown/DialogTitle";
import DialogContent from "../../Unknown/DialogContent";
import DialogActions from "../../Unknown/DialogActions";
import Typography from "../../Unknown/Typography";
import Box from "../../Unknown/Box";
import Alert from "../../Unknown/Alert";
import Button from "../../Unknown/Button";
import CircularProgress from "../../Unknown/CircularProgress";
import AppointmentAIReportReviewEditForm from "./AppointmentAIReportReviewEditForm";

export type AppointmentAIReportReviewEditDialogFormikProps = {
  isOpened: boolean;
  title: string;
  onCancel: () => void;
  errorMessage: string | null;
  translations: ReturnType<typeof useTranslations>["translations"];
};

const AppointmentAIReportReviewEditDialogFormik: FC<
  AppointmentAIReportReviewEditDialogFormikProps
> = ({ isOpened, title, onCancel, errorMessage, translations }) => {
  const { isSubmitting, resetForm, handleSubmit } = useFormikContext();

  const onClose = () => {
    onCancel();
    resetForm();
  };

  const onSaveClick = () => {
    handleSubmit();
  };

  return (
    <Dialog
      open={isOpened}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
          maxWidth: 900,
        },
      }}
    >
      <DialogTitle>
        {title}
        {translations.subtitle && (
          <Typography variant="body2" color="text.secondary">
            {translations.subtitle}
          </Typography>
        )}
      </DialogTitle>
      <DialogContent>
        {errorMessage && (
          <Box mb={2}>
            <Alert severity="error">{errorMessage}</Alert>
          </Box>
        )}
        <AppointmentAIReportReviewEditForm translations={translations} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isSubmitting} size="small">
          {translations.btnCancel}
        </Button>
        <Button
          onClick={onSaveClick}
          disabled={isSubmitting}
          startIcon={isSubmitting ? <CircularProgress size={20} /> : null}
          size="small"
        >
          {translations.btnSave}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AppointmentAIReportReviewEditDialogFormik;
